// extracted by mini-css-extract-plugin
module.exports = {"container":"yd","block":"zd","subheading":"Ad","cta":"Bd","disabled":"Cd","noBotMargin":"Dd","light":"Ed"};